import { ReactElement } from "react";
import styles from "../pageFooter/page-footer.module.css";
import { Divider } from "@justworkshr/milo-core";
import TermsAndConditions from "../../pages/register/components/termsAndConditions/TermsAndConditions";

const PageFooter = ({
  addTermsAndConditions = false,
}: {
  addTermsAndConditions?: boolean;
}): ReactElement => {
  const currentYear = new Date().getFullYear().toString();

  return (
    <footer className={styles.footer}>
      {addTermsAndConditions && <TermsAndConditions />}
      <div className={styles.dividerSpacing}>
        <Divider />
      </div>
      <div className={styles.subDividerContent}>
        &copy; <time dateTime={"2013"}>2013</time>-
        <time dateTime={currentYear}>{currentYear}</time> Justworks, Inc. and
        its affiliates. All rights reserved.
      </div>
    </footer>
  );
};

export default PageFooter;
